export default __webpack_public_path__ + "static/media/pending.639558d2.svg";